/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import { Input, Radio, Space, Divider, Button } from "antd";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { maskAWBNumber } from "../../utils";

export const commonColumn = ({
  searchValue,
  statusFilter,
  handleSearch,
  handleReset,
  handleStatusFilterChange,
  handleStatusFilterReset,
  handleCompleteBooking,
  handleUploadPOD,
  handleCreateDRS,
  uploadLoading,
  type,
  selectedRowKeys,
}) => {
  const formatDate = (str) => {
    if (!str) return "-";

    const date = new Date(str.replace(" ", "T"));

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getButtonText = (type) => {
    switch (type) {
      case "LOCK_POD_UPLOAD":
        return "Upload POD";
      case "LOCK_DRS_STATUS_UPDATE":
        return "Update Status";
      default:
        return "";
    }
  };

  return [
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
      width: 180,
      render: (text) => text,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8, width: "180px" }}>
          <Input
            placeholder="Search AWB Number"
            value={selectedKeys[0] || ""}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedKeys(value ? [value] : []);
              handleSearch(value);
            }}
            onPressEnter={() => confirm()}
            allowClear
            onClear={() => {
              setSelectedKeys([]);
              handleReset();
            }}
          />
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{
            color: filtered || searchValue ? "#1890ff" : undefined,
            fontSize: "14px",
          }}
        />
      ),
      filteredValue: searchValue ? [searchValue] : null,
    },
    // {
    //   title: "Rule ID",
    //   dataIndex: "ruleId",
    //   key: "ruleId",
    // },
    {
      title: "Received At",
      dataIndex: "receivedAt",
      key: "receivedAt",
      width: 180,
      render: (text) => formatDate(text),
    },

    {
      title: "Location",
      dataIndex: "hubAtEvent",
      key: "hubAtEvent",
    },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   ...(type !== "UNLOCK_SHPIMENT"
    //     ? {
    //         filterDropdown: ({ setSelectedKeys, clearFilters }) => (
    //           <div style={{ padding: 8, width: "200px" }}>
    //             <Radio.Group
    //               value={statusFilter || undefined}
    //               onChange={(e) => {
    //                 const value = e.target.value;
    //                 setSelectedKeys(value ? [value] : []);
    //                 handleStatusFilterChange(value);
    //               }}
    //               style={{ width: "100%" }}
    //             >
    //               <Space direction="vertical" style={{ width: "100%" }}>
    //                 <Radio value="OPEN">Open</Radio>
    //                 <Radio value="LOCKED">Locked</Radio>
    //               </Space>
    //             </Radio.Group>

    //             <Divider style={{ margin: "8px 0" }} />

    //             <Button
    //               type="primary"
    //               size="small"
    //               style={{ width: "100%" }}
    //               onClick={() => {
    //                 setSelectedKeys([]);
    //                 clearFilters();
    //                 handleStatusFilterReset();
    //               }}
    //             >
    //               Reset
    //             </Button>
    //           </div>
    //         ),

    //         filterIcon: (filtered) => (
    //           <FilterOutlined
    //             style={{
    //               color: filtered || statusFilter ? "#1890ff" : undefined,
    //               fontSize: "14px",
    //             }}
    //           />
    //         ),

    //         filteredValue: statusFilter ? [statusFilter] : null,
    //       }
    //     : {}), // <-- No filters when LOCK_NOT_BOOKED

    //   render: (text) => <span>{text.toUpperCase()}</span>,
    // },

    ...(type === "LOCK_NOT_BOOKED"
      ? [
          {
            title: "Action",
            key: "action",
            width: 150,
            align: "center",
            render: (_, record) => (
              <div style={{ display: "flex", gap: "8px" }}>
                {(record.shipmentType === "RETAIL" ||
                  record.shipmentType === "BOTH") && (
                  <Button
                    type="primary"
                    size="medium"
                    style={{
                      padding: "0 10px",
                      borderRadius: "5px",
                      backgroundColor: "#52c41a",
                      borderColor: "#52c41a",
                    }}
                    onClick={() => handleCompleteBooking(record, "RETAIL")}
                  >
                    Retail
                  </Button>
                )}

                {(record.shipmentType === "CREDIT" ||
                  record.shipmentType === "BOTH") && (
                  <Button
                    type="primary"
                    size="medium"
                    style={{ padding: "0 10px", borderRadius: "5px" }}
                    onClick={() => handleCompleteBooking(record, "CREDIT")}
                  >
                    Credit
                  </Button>
                )}
              </div>
            ),
          },
        ]
      : []),

    ...(["LOCK_DRS_PENDING"].includes(type)
      ? [
          {
            title: "Action",
            key: "action",
            width: 150,
            align: "center",
            render: (_, record) => {
              const isSelected = selectedRowKeys?.includes(record.awbNumber);
              return !isSelected ? (
                <Button
                  type="primary"
                  size="medium"
                  style={{
                    padding: "0 10px",
                    borderRadius: "5px",
                    backgroundColor: "#1890ff",
                    borderColor: "#1890ff",
                  }}
                  onClick={() => handleCreateDRS(record)}
                >
                  Create DRS
                </Button>
              ) : null;
            },
          },
        ]
      : []),

    ...(["LOCK_POD_UPLOAD", "LOCK_DRS_STATUS_UPDATE"].includes(type)
      ? [
          {
            title: "Action",
            key: "action",
            width: 150,
            align: "center",
            render: (_, record) => (
              <Button
                type="primary"
                size="medium"
                loading={uploadLoading?.[record.awbNumber]}
                style={{
                  padding: "0 10px",
                  borderRadius: "5px",
                  backgroundColor: "#1890ff",
                  borderColor: "#1890ff",
                }}
                onClick={() => handleUploadPOD(record)}
              >
                {getButtonText(type)}
              </Button>
            ),
          },
        ]
      : []),
  ];
};
